import React from "react";
import { Link } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Disclaimer from "./disclaimer";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    marginBottom: theme.spacing() * 2,
  },
  section: {
    marginBottom: theme.spacing(),
    marginTop: theme.spacing() * 2,
    "&:first-child": {
      marginTop: 0,
    },
  },
  subSection: {
    marginBottom: theme.spacing() * 3,
  },
  serviceLogo: {
    maxHeight: 50,
    maxWidth: 50,
    verticalAlign: "middle",
  },
  serviceDescription: {
    display: "inline-block",
    verticalAlign: "middle",
  },
  small: { fontSize: "small" },
}));

export default ({
  service,
  updateService,
  isPrint,
  serviceLevels,
  currencyCaption,
}) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.section}>
        Service
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.subSection}
      >
        Cards not marked for evaluation will be immediately sent to the grading
        agency you choose below. Cards{" "}
        <Link to="/evaluate" target="_blank">
          marked for evaluation
        </Link>{" "}
        will not incur grading fees.
      </Typography>
      <RadioGroup name="service" value={service} onChange={updateService}>
        <Grid container alignItems="top" justify="space-around">
          {Object.keys(serviceLevels).map((key) => (
            <Grid
              item
              xs={12}
              sm={6}
              lg={3}
              className={classes.gridItem}
              key={key}
            >
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  {serviceLevels[key].label}
                </FormLabel>
                <FormControlLabel
                  key={key}
                  value={key}
                  control={
                    <Radio
                      disabled={!isPrint && serviceLevels[key].disabled}
                      required
                    />
                  }
                  label={
                    <>
                      {/* eslint-disable-next-line */}
                      <img
                        className={classes.serviceLogo}
                        src={serviceLevels[key].logo}
                      />{" "}
                      <span className={classes.serviceDescription}>
                        {serviceLevels[key].label} ({currencyCaption}
                        {serviceLevels[key].price.toFixed(2)})
                      </span>
                    </>
                  }
                />
              </FormControl>
            </Grid>
          ))}
        </Grid>
      </RadioGroup>
      {!isPrint ? <Disclaimer /> : null}
    </>
  );
};
